import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { UnauthorizedUserError } from '@core/authentication/exceptions/unauthorized-user-error.exception';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { IndicationPopUpComponent } from './indication-pop-up/indication-pop-up.component';

export interface NavigationItem {
  id: string;
  url: string;
  permissionName: string | null;
  featureFlag?: string;
}

export const NAVIGATION: NavigationItem[] = [
  {
    id: 'reports.maintenances',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/manutencoes`,
    permissionName: 'reports-dashboard',

  },
  {
    id: 'reports.quotations',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/orcamentos`,
    permissionName: 'reports-quotations',
  },
  {
    id: 'reports.volumetry',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/volumetria`,
    permissionName: 'reports-volumetry',
  },
  {
    id: 'reports.deadlines',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/prazos`,
    permissionName: 'reports-deadlines',
  },
  {
    id: 'reports.equipments',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/equipamentos`,
    permissionName: 'reports-equipments',
  },
  {
    id: 'reports.forms',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/formularios`,
    permissionName: 'reports-forms',
  },
  {
    id: 'reports.ratings',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/avaliacoes`,
    permissionName: 'reports-ratings',
  },
  {
    id: 'reports.company-comparison',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/comparar-empresas`,
    permissionName: 'reports-company-comparison',
  },
  {
    id: 'reports.company-ranking',
    url: `${environment.MOUNTDOOM_URL}/#/relatorios/classificacao-empresas`,
    permissionName: 'reports-company-ranking',
  },
  {
    id: 'pendencies',
    url: `${environment.MOUNTDOOM_2_URL}/#/pendencias`,
    permissionName: 'pendencies-list'
  },
  {
    id: 'maintenances.list',
    url: `${environment.MOUNTDOOM_URL}/#/manutencoes`,
    permissionName: 'maintenances-list',
  },
  {
    id: 'maintenances.map',
    url: `${environment.MOUNTDOOM_URL}/#/manutencoes/mapa`,
    permissionName: 'maintenances-list',
  },
  {
    id: 'quotation',
    url: `${environment.MOUNTDOOM_URL}/#/orcamentos`,
    permissionName: 'quotations-list',
  },
  {
    id: 'quotation.list',
    url: `${environment.MOUNTDOOM_URL}/#/localizacoes`,
    permissionName: 'locations-list',
  },
  {
    id: 'quotation.locations-groups',

    url: `${environment.MOUNTDOOM_URL}/#/localizacoes/grupos`,
    permissionName: 'locations-groups-list',
  },
  {
    id: 'equipments.list',
    url: `${environment.MOUNTDOOM_URL}/#/equipamentos`,
    permissionName: 'equipments-list',

  },
  {
    id: 'equipments.approvals-equipments-list',
    url: `${environment.MOUNTDOOM_URL}/#/equipamentos/aprovacoes`,
    permissionName: 'approvals-equipments-list',

  },
  {
    id: 'recurrences',
    url: `${environment.MOUNTDOOM_URL}/#/recorrencias`,
    permissionName: 'recurrences-list',
  },
  {
    id: 'settings.profile',
    url: `${environment.MOUNTDOOM_URL}/#/perfil`,
    permissionName: null
  },
  {
    id: 'settings.imports',
    url: `${environment.MOUNTDOOM_URL}/#/importacoes`,
    permissionName: 'imports-list',
  },
  {
    id: 'settings.registers.register_deadlines_contracts',
    url: `${environment.MOUNTDOOM_URL}/#/contratos-de-prazos`,
    permissionName: 'deadlines-contracts-list',
  },
  {
    id: 'settings.registers.registers_labels',
    url: `${environment.MOUNTDOOM_URL}/#/etiquetas`,
    permissionName: 'labels-list',
  },
  {
    id: 'settings.registers.registers_forms',
    url: `${environment.MOUNTDOOM_URL}/#/formularios`,
    permissionName: 'forms-list',
  },
  {
    id: 'settings.registers.registers_problems',
    url: `${environment.MOUNTDOOM_URL}/#/problemas`,
    permissionName: 'problems-list',
  },
  {
    id: 'settings.registers.registers_segments',
    url: `${environment.MOUNTDOOM_URL}/#/segmentos`,
    permissionName: 'segments-list',
  },
  {
    id: 'settings.registers.registers_equipments_types',
    url: `${environment.MOUNTDOOM_URL}/#/equipamentos/tipos`,
    permissionName: 'equipments-types-list',
  },
  {
    id: 'settings.registers.registers_maintenance_types',
    url: `${environment.MOUNTDOOM_URL}/#/manutencoes/tipos`,
    permissionName: 'maintenances-types-list',
  },
  {
    id: 'settings.registers.registers_products_services',
    url: `${environment.MOUNTDOOM_URL}/#/produtos-e-servicos`,
    permissionName: 'products-services-list',
  },
  {
    id: 'settings.registers.registers_pendencies_types',
    url: `${environment.MOUNTDOOM_2_URL}/#/tipos-de-pendencias`,
    permissionName: 'pendencies-types-list'
  },
  {
    id: 'settings.accounts',
    url: `${environment.MOUNTDOOM_URL}/#/usuarios`,
    permissionName: 'users-list',
  },
  {
    id: 'settings.accounts.groups',
    url: `${environment.MOUNTDOOM_URL}/#/grupos`,
    permissionName: 'groups-list',
  },
  {
    id: 'settings.accounts.companies',
    url: `${environment.MOUNTDOOM_URL}/#/empresas`,
    permissionName: 'settings-companies-list',
  },
  {
    id: 'settings.accounts.account',
    url: `${environment.MOUNTDOOM_URL}/#/configuracoes/conta`,
    permissionName: 'accounts-configuration',
  },
  {
    id: 'settings.developer.integration',
    url: `${environment.MOUNTDOOM_URL}/#/desenvolvedor/api-de-integracao`,
    permissionName: 'developer-list',
  },
  {
    id: 'settings.developer.integration-logs',
    url: `${environment.MOUNTDOOM_URL}/#/desenvolvedor/historico-de-eventos`,
    permissionName: 'developer-list',
  },
];


@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private sidebarFolded = new Subject<any>();

  private overlayRef: OverlayRef;

  constructor(
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly overlay: Overlay,
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly authenticationService: AuthenticationService,
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => route.firstChild),
        map((route) => {
          const activatedRouteTitle = route.snapshot.data && route.snapshot.data.title;
          const activatedChildTitle = route.children[0] && route.children[0].snapshot && route.children[0].snapshot.data.title;
          return activatedRouteTitle || activatedChildTitle;
        })
      )
      .subscribe((title: string | undefined) => {
        const corporateNameTranslated = this.translateService.instant('CORE.SERVICES.NAVIGATION.TITLES.CORPORATE');

        if (title) {
          const titleTranslated = this.translateService.instant(title);
          this.titleService.setTitle(`${titleTranslated} - ${corporateNameTranslated}`);

          return;
        }

        this.titleService.setTitle(`${corporateNameTranslated} - Field Control`);
      });


    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        filter(() => !!this.overlayRef),
      )
      .subscribe(() => this.disposePopUp());
  }

  public get eventSidebarFolded(): Observable<boolean> {
    return this.sidebarFolded.asObservable();
  }

  public readonly navigation: any[] = [
    {
      id: 'reports',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.TITLE'),
      type: 'collapsable',
      icon: 'dashboard',
      hidden: true,
      children: [
        {
          type: 'item',
          id: 'maintenances',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.MAINTENANCES'),
          url: '/relatorios/manutencoes',
          exactMatch: true,
          permissionName: 'reports-dashboard',
          hidden: true
        },
        {
          type: 'item',
          id: 'quotations',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.QUOTATIONS'),
          url: '/relatorios/orcamentos',
          exactMatch: true,
          permissionName: 'reports-quotations',
          hidden: true
        },
        {
          type: 'item',
          id: 'volumetry',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.VOLUMETRY'),
          url: '/relatorios/volumetria',
          exactMatch: true,
          permissionName: 'reports-volumetry',
          hidden: true
        },
        {
          type: 'item',
          id: 'deadlines',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.DEADLINES'),
          url: '/relatorios/prazos',
          exactMatch: true,
          permissionName: 'reports-deadlines',
          hidden: true
        },
        {
          type: 'item',
          id: 'reports_equipments',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.EQUIPMENTS'),
          url: '/relatorios/equipamentos',
          exactMatch: true,
          permissionName: 'reports-equipments',
          hidden: true
        },
        {
          type: 'item',
          id: 'reports_forms',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.FORMS'),
          url: '/relatorios/formularios',
          exactMatch: true,
          permissionName: 'reports-forms',
          hidden: true
        },
        {
          type: 'item',
          id: 'reports_ratings',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.RATINGS'),
          url: '/relatorios/avaliacoes',
          exactMatch: true,
          permissionName: 'reports-ratings',
          hidden: true
        },
        {
          type: 'item',
          id: 'reports_company-comparison',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.COMPANY_COMPARISON'),
          url: '/relatorios/comparar-empresas',
          exactMatch: true,
          permissionName: 'reports-company-comparison',
          hidden: true
        },
        {
          type: 'item',
          id: 'reports_company-ranking',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.REPORTS.COMPANY_RANKING'),
          url: '/relatorios/classificacao-empresas',
          exactMatch: true,
          permissionName: 'reports-company-ranking',
          hidden: true
        }
      ]
    },
    {
      id: 'maintenance',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.MAINTENANCES.TITLE'),
      type: 'collapsable',
      icon: 'business_center',
      hidden: true,
      children: [
        {
          id: 'maintenances-list',
          type: 'item',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.MAINTENANCES.LIST'),
          url: '/manutencoes',
          permissionName: 'maintenances-list',
          exactMatch: true,
          hidden: true
        },
        {
          id: 'maintenances-map',
          type: 'item',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.MAINTENANCES.MAP'),
          url: '/manutencoes/mapa',
          permissionName: 'maintenances-list',
          exactMatch: true,
          hidden: true
        }
      ]
    },
    {
      id: 'quotation',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.QUOTATIONS'),
      type: 'item',
      icon: 'attach_money',
      url: '/orcamentos',
      permissionName: 'quotations-list',
      exactMatch: true,
      hidden: true
    },
    {
      id: 'locations',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.LOCATIONS.TITLE'),
      type: 'collapsable',
      icon: 'place',
      hidden: true,
      children: [
        {
          type: 'item',
          id: 'locations_list',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.LOCATIONS.LIST'),
          url: '/localizacoes',
          exactMatch: true,
          permissionName: 'locations-list',
          hidden: true
        },
        {
          type: 'item',
          id: 'locations_groups',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.LOCATIONS.GROUPS'),
          url: '/localizacoes/grupos',
          exactMatch: true,
          permissionName: 'locations-groups-list',
          hidden: true
        }
      ]
    },
    {
      id: 'equipments',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.EQUIPMENTS.TITLE'),
      type: 'collapsable',
      icon: 'storage',
      hidden: true,
      children: [
        {
          type: 'item',
          id: 'equipments_list',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.EQUIPMENTS.LIST'),
          url: '/equipamentos',
          exactMatch: true,
          permissionName: 'equipments-list',
          hidden: true
        },
        {
          type: 'item',
          id: 'approvals_equipments_list',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.EQUIPMENTS.APPROVALS'),
          url: '/equipamentos/aprovacoes',
          exactMatch: true,
          permissionName: 'approvals-equipments-list',
          hidden: true
        }
      ]
    },
    {
      id: 'recurrences',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.RECURRENCES'),
      type: 'item',
      icon: 'today',
      url: '/recorrencias',
      exactMatch: true,
      permissionName: 'recurrences-list',
      hidden: true
    },
    {
      id: 'settings',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.TITLE'),
      type: 'collapsable',
      icon: 'settings',
      classes: 'item-configuration',
      hidden: true,
      children: [
        {
          id: 'profile',
          type: 'item',
          hidden: true,
          exactMatch: true,
          permissionName: null,
          url: '/perfil',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.PROFILE'),
        },
        {
          id: 'imports',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.IMPORTS'),
          type: 'item',
          exactMatch: true,
          url: '/importacoes',
          permissionName: 'imports-list',
          hidden: true
        },
        {
          id: 'registers',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.REGISTERS'),
          classes: 'item-register',
          type: 'collapsable',
          hidden: true,
          children: [
            {
              type: 'item',
              id: 'register_deadlines_contracts',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.DEADLINES_CONTRACTS'),
              url: '/contratos-de-prazos',
              permissionName: 'deadlines-contracts-list',
              exactMatch: true,
              hidden: true
            },
            {
              type: 'item',
              id: 'registers_labels',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.LABELS'),
              url: '/etiquetas',
              exactMatch: true,
              permissionName: 'labels-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'registers_forms',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.FORMS'),
              url: '/formularios',
              exactMatch: true,
              permissionName: 'forms-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'registers_problems',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.PROBLEMS'),
              url: '/problemas',
              exactMatch: true,
              permissionName: 'problems-list',
              hidden: true
            },
            {
              id: 'registers_segments',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SEGMENTS'),
              type: 'item',
              url: '/segmentos',
              exactMatch: true,
              permissionName: 'segments-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'registers_equipments_types',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.EQUIPMENTS.TYPES'),
              url: '/equipamentos/tipos',
              exactMatch: true,
              permissionName: 'equipments-types-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'registers_maintenance_types',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.MAINTENANCES_TYPES'),
              url: '/manutencoes/tipos',
              exactMatch: true,
              permissionName: 'maintenances-types-list',
              hidden: true
            }
          ]
        },
        {
          id: 'settings_accounts',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.ACCOUNT'),
          type: 'collapsable',
          classes: 'item-accounts',
          hidden: true,
          children: [
            {
              type: 'item',
              id: 'settings_users',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.USERS'),
              url: '/usuarios',
              exactMatch: true,
              permissionName: 'users-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'settings_groups',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.GROUPS'),
              url: '/grupos',
              exactMatch: true,
              permissionName: 'groups-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'settings_companies',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.COMPANIES'),
              url: '/empresas',
              exactMatch: true,
              permissionName: 'settings-companies-list',
              hidden: true
            },
            {
              type: 'item',
              id: 'settings_account',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.ACCOUNT_INFORMATION'),
              url: '/configuracoes/conta',
              exactMatch: true,
              permissionName: 'accounts-configuration',
              hidden: true
            }
          ]
        },
        {
          id: 'settings_developer',
          title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.DEVELOPER'),
          type: 'collapsable',
          classes: 'item-developer',
          hidden: true,
          children: [
            {
              id: 'integration_api',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.INTEGRATION_API'),
              type: 'item',
              exactMatch: true,
              url: '/desenvolvedor/api-de-integracao',
              permissionName: 'developer-list',
              hidden: true
            },
            {
              id: 'integration_logs',
              title: this.translateService.instant('CORE.SERVICES.NAVIGATION.SETTINGS.INTEGRATION_LOGS'),
              type: 'item',
              exactMatch: true,
              url: '/desenvolvedor/historico-de-eventos',
              permissionName: 'developer-list',
              hidden: true
            },
          ]
        },
      ]
    },
    {
      id: 'indication',
      title: this.translateService.instant('CORE.SERVICES.NAVIGATION.INDICATION.BUTTON'),
      type: 'item',
      icon: 'handshake',
      externalUrl: true,
      openInNewTab: true,
      permissionName: null,
      hidden: true,
      url: `https://bit.ly/3PuA39s`
    }
  ];

  public sendSidebarFolded(): void {
    this.sidebarFolded.next();
  }

  private disposePopUp(): void {
    this.overlayRef.dispose();
    this.overlayRef = null;
    localStorage.setItem(`${moment().format('YYYY-MM')}-indication-popup`, 'shown');
  }

  private toggleIndicationPopUp(): void {
    if (this.overlayRef) {
      this.disposePopUp();
    } else {
      this.overlayRef = this.overlay.create({
        positionStrategy: this.overlay.position()
          .global()
          .bottom('30px')
          .left('230px')

      });
      const componentRef = this.overlayRef.attach(new ComponentPortal(IndicationPopUpComponent));
      componentRef.instance.popUpClosed.subscribe(() => {
        this.disposePopUp();
      });
    }
  }

  public showSupplierIndicationPopUpForCurrentMonth(): void {
    const isPopUpShowInCurrentMonth = localStorage.getItem(`${moment().format('YYYY-MM')}-indication-popup`);
    if (isPopUpShowInCurrentMonth) { return; }

    setTimeout(() => {
      this.toggleIndicationPopUp();
    }, 0);
  }


  public getFirstVisibleItem(throwErrorIfNotExist?: boolean): NavigationItem {
    const item = NAVIGATION.find((navigation) => {
      return navigation.permissionName == null || this.authenticationService.hasPermission(navigation.permissionName);
    });

    if (throwErrorIfNotExist && !item) {
      throw new UnauthorizedUserError();
    }

    return item;
  }

  public getItemByUrl(url: string): NavigationItem {
    const absoluteUrl = `${environment.MOUNTDOOM_URL}/#${url}`;
    const item = NAVIGATION.find((navigation) => {
      return navigation.url === absoluteUrl;
    });

    return item;
  }
}
